const OPTION_VALUES = {
    OVERWRITE: 'overwrite',
    SET: 'set',
    CLEAR: 'clear',
    MATH: 'math',
};

const LIMITS = {
    MIN_QUANTITY: -999999999,
    MAX_QUANTITY: 999999999,
    QUANTITY_MAXLENGTH: 13, // e.g. -100000000.99
};

const FIELD_TYPES = {
    RADIO: 'radio',
    SELECT_ONE: 'select-one',
    SELECT_MULTIPLE: 'select-multiple',
    EMAIL: 'email',
    TEXT_AREA: 'textarea',
    TEXT: 'text',
    HIDDEN: 'hidden',
};

export {
    OPTION_VALUES,
    LIMITS,
    FIELD_TYPES,
};
